import React from "react";

import ViewContainer from "../../../../components/layout/view/ViewContainer";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentPanelHeader from "../../../../components/layout/content/ContentPanelHeader";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Text from "../../../../components/typography/Text";

import "./TalentDetailsView.css";

export default function TalentDetailsView({ profile }) {
  const details = [
    {
      label: "Visibility",
      value: profile?.visibility || "Private",
    },
    {
      label: "Sports",
      value: profile?.sports?.length || 0,
    },
    {
      label: "Experiences",
      value: profile?.experiences?.length || 0,
    },
    {
      label: "Achievements",
      value: profile?.achievements?.length || 0,
    },
  ];

  return (
    <ViewContainer>
      <ContentPanel>
        <ContentPanelHeader
          title="Talent Details"
          subTitle="Overview of your Talent ID profile."
        />

        <div className="user-talent__detail-list">
          {details.map((item) => (
            <ContentItem key={item.label} className="user-talent__detail-item">
              <Text as="span" tone="secondary" size="sm">
                {item.label}
              </Text>

              <Text as="span" size="sm">
                {item.value}
              </Text>
            </ContentItem>
          ))}
        </div>
      </ContentPanel>
    </ViewContainer>
  );
}
